import { render } from "./PriceBatchAudit.vue?vue&type=template&id=2485d73e"
import script from "./PriceBatchAudit.vue?vue&type=script&lang=js"
export * from "./PriceBatchAudit.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__